import { useEffect, useMemo, useState } from "react";

export const useSyncProp = <T>(defaultState: T) => {
    const [_state, setState] = useState<T>();
    const state = useMemo(() => {
        if (_state === undefined) return defaultState;
        return _state;
    }, [defaultState, _state]);
    useEffect(() => {
        setState(undefined)
    }, [defaultState]);
    return [state, setState] as const;
}